import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative bg-cream pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden" data-id="element-142">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-143">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-144">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-145">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-146">
              ¿Cansada de los berrinches que terminan en gritos y culpa?
            </h1>
            <p className="text-lg md:text-xl text-brown mb-10 leading-relaxed font-light" data-id="element-147">
              Detén las rabietas en 3 minutos o menos con el método "Conexión
              Antes que Corrección", sin castigos físicos ni angustia para tu
              hijo.
            </p>
            <CTAButton className="w-full md:w-auto text-sm md:text-base" data-id="element-148">
              ¡SÍ, QUIERO CRIAR CON CALMA Y SIN CULPA!
            </CTAButton>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-149">
            <div className="absolute inset-0 bg-teal/10 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-150"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jnFDwinyihPyttbVV26GvB/imagen_2.png" alt="Madre e hijo en calma mostrando el método" className="rounded-3xl shadow-soft w-full object-cover aspect-[4/3] md:aspect-square" data-id="element-151" />
          </motion.div>
        </div>
      </div>
    </section>;
}